import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { EnglishPrivacyPolicyContent } from '../components/EnglishPrivacyPolicyContent';
import { useLanguage } from '../contexts/LanguageContext';
export function DatenschutzPage() {
  const {
    language
  } = useLanguage();
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-530">
      <Navigation data-id="element-531" />
      <main className="pt-24 pb-16" data-id="element-532">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-533">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-534">
            {language === 'de' ? 'Datenschutzerklärung' : 'Privacy Policy'}
          </h1>

          {language === 'en' ? <EnglishPrivacyPolicyContent data-id="element-535" /> : <div className="prose prose-invert max-w-none space-y-8 text-gray-400" data-id="element-536">
              <section data-id="element-537">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-538">
                  1. Datenschutz auf einen Blick
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-539">
                  Allgemeine Hinweise
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-540">
                  Die folgenden Hinweise geben einen einfachen Überblick
                  darüber, was mit Ihren personenbezogenen Daten passiert, wenn
                  Sie diese Website besuchen. Personenbezogene Daten sind alle
                  Daten, mit denen Sie persönlich identifiziert werden können.
                  Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
                  unserer unter diesem Text aufgeführten Datenschutzerklärung.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-541">
                  Datenerfassung auf dieser Website
                </h3>

                <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-542">
                  Wer ist verantwortlich für die Datenerfassung auf dieser
                  Website?
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-543">
                  Die Datenverarbeitung auf dieser Website erfolgt durch den
                  Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt
                  „Hinweis zur Verantwortlichen Stelle" in dieser
                  Datenschutzerklärung entnehmen.
                </p>

                <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-544">
                  Wie erfassen wir Ihre Daten?
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-545">
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns
                  diese mitteilen. Hierbei kann es sich z. B. um Daten handeln,
                  die Sie in ein Kontaktformular eingeben.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-546">
                  Andere Daten werden automatisch oder nach Ihrer Einwilligung
                  beim Besuch der Website durch unsere IT-Systeme erfasst. Das
                  sind vor allem technische Daten (z. B. Internetbrowser,
                  Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                  dieser Daten erfolgt automatisch, sobald Sie diese Website
                  betreten.
                </p>

                <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-547">
                  Wofür nutzen wir Ihre Daten?
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-548">
                  Ein Teil der Daten wird erhoben, um eine fehlerfreie
                  Bereitstellung der Website zu gewährleisten. Andere Daten
                  können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                </p>

                <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-549">
                  Welche Rechte haben Sie bezüglich Ihrer Daten?
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-550">
                  Sie haben jederzeit das Recht, unentgeltlich Auskunft über
                  Herkunft, Empfänger und Zweck Ihrer gespeicherten
                  personenbezogenen Daten zu erhalten. Sie haben außerdem ein
                  Recht, die Berichtigung oder Löschung dieser Daten zu
                  verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung
                  erteilt haben, können Sie diese Einwilligung jederzeit für die
                  Zukunft widerrufen. Außerdem haben Sie das Recht, unter
                  bestimmten Umständen die Einschränkung der Verarbeitung Ihrer
                  personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen
                  ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-551">
                  Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können
                  Sie sich jederzeit an uns wenden.
                </p>

                <h4 className="text-lg font-semibold text-white mb-2 mt-4" data-id="element-552">
                  Analyse-Tools und Tools von Drittanbietern
                </h4>
                <p className="leading-relaxed mb-4" data-id="element-553">
                  Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch
                  ausgewertet werden. Das geschieht vor allem mit sogenannten
                  Analyseprogrammen.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-554">
                  Detaillierte Informationen zu diesen Analyseprogrammen finden
                  Sie in der folgenden Datenschutzerklärung.
                </p>
              </section>

              <section data-id="element-555">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-556">
                  2. Hosting
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-557">
                  Webflow
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-558">
                  Wir hosten unsere Website bei Webflow. Anbieter ist die
                  Webflow, Inc., 398 11th Street, 2nd Floor, San Francisco, CA
                  94103, USA (nachfolgend Webflow). Wenn Sie unsere Website
                  besuchen, erfasst Webflow verschiedene Logfiles inklusive
                  Ihrer IP-Adressen.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-559">
                  Webflow ist ein Tool zum Erstellen und zum Hosten von
                  Websites. Webflow speichert Cookies oder sonstige
                  Wiedererkennungstechnologien, die für die Darstellung der
                  Seite, zur Bereitstellung bestimmter Webseitenfunktionen und
                  zur Gewährleistung der Sicherheit erforderlich sind
                  (notwendige Cookies).
                </p>
                <p className="leading-relaxed mb-4" data-id="element-560">
                  Details entnehmen Sie der Datenschutzerklärung von Webflow:{' '}
                  <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-561">
                    https://webflow.com/legal/eu-privacy-policy
                  </a>
                  .
                </p>
                <p className="leading-relaxed mb-4" data-id="element-562">
                  Die Verwendung von Webflow erfolgt auf Grundlage von Art. 6
                  Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an
                  einer möglichst zuverlässigen Darstellung unserer Website.
                  Sofern eine entsprechende Einwilligung abgefragt wurde,
                  erfolgt die Verarbeitung ausschließlich auf Grundlage von Art.
                  6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG, soweit die
                  Einwilligung die Speicherung von Cookies oder den Zugriff auf
                  Informationen im Endgerät des Nutzers (z. B.
                  Device-Fingerprinting) im Sinne des TTDSG umfasst. Die
                  Einwilligung ist jederzeit widerrufbar.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-563">
                  Die Datenübertragung in die USA wird auf die
                  Standardvertragsklauseln der EU-Kommission gestützt. Details
                  finden Sie hier:{' '}
                  <a href="https://webflow.com/legal/eu-privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-564">
                    https://webflow.com/legal/eu-privacy-policy
                  </a>
                  .
                </p>
              </section>

              <section data-id="element-565">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-566">
                  3. Allgemeine Hinweise und Pflichtinformationen
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-567">
                  Datenschutz
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-568">
                  Die Betreiber dieser Seiten nehmen den Schutz Ihrer
                  persönlichen Daten sehr ernst. Wir behandeln Ihre
                  personenbezogenen Daten vertraulich und entsprechend den
                  gesetzlichen Datenschutzvorschriften sowie dieser
                  Datenschutzerklärung.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-569">
                  Wenn Sie diese Website benutzen, werden verschiedene
                  personenbezogene Daten erhoben. Personenbezogene Daten sind
                  Daten, mit denen Sie persönlich identifiziert werden können.
                  Die vorliegende Datenschutzerklärung erläutert, welche Daten
                  wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie
                  und zu welchem Zweck das geschieht.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-570">
                  Wir weisen darauf hin, dass die Datenübertragung im Internet
                  (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken
                  aufweisen kann. Ein lückenloser Schutz der Daten vor dem
                  Zugriff durch Dritte ist nicht möglich.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-571">
                  Hinweis zur verantwortlichen Stelle
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-572">
                  Die verantwortliche Stelle für die Datenverarbeitung auf
                  dieser Website ist:
                </p>
                <p className="leading-relaxed mb-4" data-id="element-573">
                  CRM Kraft LLC
                  <br data-id="element-574" />
                  Vertreten durch: Justus Kraft
                  <br data-id="element-575" />
                  7901 4th St. N, Ste. 300
                  <br data-id="element-576" />
                  St. Petersburg, FL 33702
                  <br data-id="element-577" />
                  United States of America
                  <br data-id="element-578" />
                  Telefon: +49 157 35999071
                  <br data-id="element-579" />
                  E-Mail: justus@crm-kraft.de
                </p>
                <p className="leading-relaxed mb-4" data-id="element-580">
                  Verantwortliche Stelle ist die natürliche oder juristische
                  Person, die allein oder gemeinsam mit anderen über die Zwecke
                  und Mittel der Verarbeitung von personenbezogenen Daten (z. B.
                  Namen, E-Mail-Adressen o. Ä.) entscheidet.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-581">
                  Speicherdauer
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-582">
                  Soweit innerhalb dieser Datenschutzerklärung keine speziellere
                  Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen
                  Daten bei uns, bis der Zweck für die Datenverarbeitung
                  entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend
                  machen oder eine Einwilligung zur Datenverarbeitung
                  widerrufen, werden Ihre Daten gelöscht, sofern wir keine
                  anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
                  personenbezogenen Daten haben (z. B. steuer- oder
                  handelsrechtliche Aufbewahrungsfristen); im letztgenannten
                  Fall erfolgt die Löschung nach Fortfall dieser Gründe.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-583">
                  SSL- bzw. TLS-Verschlüsselung
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-584">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der
                  Übertragung vertraulicher Inhalte, wie zum Beispiel
                  Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber
                  senden, eine SSL- bzw. TLS-Verschlüsselung. Eine
                  verschlüsselte Verbindung erkennen Sie daran, dass die
                  Adresszeile des Browsers von „http://" auf „https://" wechselt
                  und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-585">
                  Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können
                  die Daten, die Sie an uns übermitteln, nicht von Dritten
                  mitgelesen werden.
                </p>
              </section>

              <section data-id="element-586">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-587">
                  4. Datenerfassung auf dieser Website
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-588">
                  Cookies
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-589">
                  Unsere Internetseiten verwenden so genannte „Cookies". Cookies
                  sind kleine Textdateien und richten auf Ihrem Endgerät keinen
                  Schaden an. Sie werden entweder vorübergehend für die Dauer
                  einer Sitzung (Session-Cookies) oder dauerhaft (permanente
                  Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies
                  werden nach Ende Ihres Besuchs automatisch gelöscht.
                  Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis
                  Sie diese selbst löschen oder eine automatische Löschung durch
                  Ihren Webbrowser erfolgt.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-590">
                  Kontaktformular
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-591">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen,
                  werden Ihre Angaben aus dem Anfrageformular inklusive der von
                  Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
                  Anfrage und für den Fall von Anschlussfragen bei uns
                  gespeichert. Diese Daten geben wir nicht ohne Ihre
                  Einwilligung weiter.
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-592">
                  Anfrage per E-Mail, Telefon oder Telefax
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-593">
                  Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren,
                  wird Ihre Anfrage inklusive aller daraus hervorgehenden
                  personenbezogenen Daten (Name, Anfrage) zum Zwecke der
                  Bearbeitung Ihres Anliegens bei uns gespeichert und
                  verarbeitet. Diese Daten geben wir nicht ohne Ihre
                  Einwilligung weiter.
                </p>
              </section>

              <section data-id="element-594">
                <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-595">
                  5. Plugins und Tools
                </h2>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-596">
                  YouTube
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-597">
                  Diese Website bindet Videos der Website YouTube ein. Betreiber
                  der Website ist die Google Ireland Limited („Google"), Gordon
                  House, Barrow Street, Dublin 4, Irland.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-598">
                  Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in
                  der Datenschutzerklärung von YouTube unter:{' '}
                  <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-599">
                    https://policies.google.com/privacy?hl=de
                  </a>
                  .
                </p>

                <h3 className="text-xl font-semibold text-white mb-3 mt-6" data-id="element-600">
                  Google Web Fonts
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-601">
                  Diese Seite nutzt zur einheitlichen Darstellung von
                  Schriftarten so genannte Web Fonts, die von Google
                  bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr
                  Browser die benötigten Web Fonts in ihren Browsercache, um
                  Texte und Schriftarten korrekt anzuzeigen.
                </p>
              </section>
            </div>}
        </div>
      </main>
      <Footer data-id="element-602" />
    </div>;
}